import { createContext, Dispatch, SetStateAction } from 'react';

export interface ProductionCalendarContextProps {
  currentDate: Date;
  setCurrentDate: Dispatch<SetStateAction<Date>>;
}

export const ProductionCalendarContext =
  createContext<ProductionCalendarContextProps | null>(null);
